/**
 * @generated SignedSource<<28bbbfde33bafe9b705fbaaccd4c476a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type loansPage_DismissMutation$variables = {
  dismissed?: boolean | null | undefined;
  txnId: string;
};
export type loansPage_DismissMutation$data = {
  readonly loanDismissCandidate: {
    readonly dismissed: boolean | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type loansPage_DismissMutation = {
  response: loansPage_DismissMutation$data;
  variables: loansPage_DismissMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dismissed"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "txnId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "dismissed",
    "variableName": "dismissed"
  },
  {
    "kind": "Variable",
    "name": "txnId",
    "variableName": "txnId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dismissed",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "loansPage_DismissMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "LoanDismissCandidateMutationPayload",
        "kind": "LinkedField",
        "name": "loanDismissCandidate",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "loansPage_DismissMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "LoanDismissCandidateMutationPayload",
        "kind": "LinkedField",
        "name": "loanDismissCandidate",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72eb570fe2c5c17c177126ff2a220925",
    "id": null,
    "metadata": {},
    "name": "loansPage_DismissMutation",
    "operationKind": "mutation",
    "text": "mutation loansPage_DismissMutation(\n  $txnId: ID!\n  $dismissed: Boolean\n) {\n  loanDismissCandidate(txnId: $txnId, dismissed: $dismissed) {\n    dismissed\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "77d15279d286d4557892319e5deccd0a";

export default node;
